import { Edit, SimpleForm, SelectInput, TextInput, email, required, useTranslate } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';

export const AdminEdit = () => {
  const translate = useTranslate();
  return (
    <Edit redirect="list" mutationMode="pessimistic">
      <SimpleForm toolbar={<MyToolbar resource="admins" />}>
        <MyFormContainer>
          <TextInput source="full_name" validate={required()} />
          <TextInput source="email" type="email" validate={[required(), email()]} />
          <TextInput source="contact_no" />
          <SelectInput
            source="status"
            choices={[
              { id: 1, name: translate('common.status.active', { _: 'Activo' }) },
              { id: 0, name: translate('common.status.inactive', { _: 'Inactivo' }) },
            ]}
          />
        </MyFormContainer>
      </SimpleForm>
    </Edit>
  );
};

export default AdminEdit;
